import { Component } from '@angular/core';
import { BreachTypeService } from '../breach-type.service';
import { BreachType } from '../breach-type';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../shared/notification.service';

@Component({
  selector: 'app-breach-type-edit',
  templateUrl: 'edit.component.html',
})
export class BreachTypeEditComponent {
  /**
   * Details of the breachType being edited.
   */
  public breachType: BreachType;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {BreachTypeService} breachTypeService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private breachTypeService: BreachTypeService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.breachTypeService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadBreachType(params.id));
  }

  /**
   * Perform the edit action which send the edited breachType to the backend.
   */
  public edit() {
    const editBreachType = this.breachTypeService
      .updateBreachType(this.breachType.id, this.breachType)
      .subscribe(
        (result: BreachType) => {
          this.notificationService.success(
            `Breach Type Updated`,
            `The breach Type ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.breachType = new BreachType();
          editBreachType.unsubscribe();
          this.router.navigate(['/breach-types']);
        },
        err => {
          this.notificationService.error(
            `Breach Type Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/breach-types']);
        },
      );
  }

  /**
   * Loads the requested breachType so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadBreachType(id: string) {
    this.breachTypeService.findBreachType(id).subscribe(
      result => {
        this.breachType = result;
      },
      err => {
        this.notificationService.error(
          `Breach Type Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/breach-types']);
      },
    );
  }
}
